<div class="question-wrapper">
	
	<div class="question-count">Question {{ question?.index }}</div>
	
	<div class="question-container">
		
		<h1>{{ question?.text }}</h1>
	
	</div>
	
	<!--Question Form-->
	
	@if (questionForm) {
		
		<form [formGroup]="questionForm" class="question-form-container">
			
			@if (question?.availableAnswers) {
				
				<div class="answers-container">
					
					<p-selectbutton [options]="question?.availableAnswers" formControlName="selectedAnswers" [multiple]="true" optionLabel="name" optionValue="value"
					                class="wrap-select"></p-selectbutton>
				
				</div>
				
			}
			
			<div class="notes-container">
				
				<textarea pTextarea formControlName="answer" placeholder="Notes"></textarea>
			
			</div>
			
			@if (question?.hasUploader) {
				
				<div class="image-uploader-container">
					
					<div class="image-uploader-inner">
						
						<input #imageUploader type="file" accept="image/*" multiple (change)="uploadImages($event)" formControlName="files">
						
						<div class="image-zone">
							
							<span class="material-symbols-outlined">cloud_upload</span>
							
							<button class="browse-button" (click)="selectFiles($event)">Select Files</button>
						
						</div>
					
					</div>
					
					<div class="file-list">
						
						@for (uploadedFile of selectedFiles; track $index) {
							<app-upload-file [file]="uploadedFile" (onDeleteFile)="onDeleteFile($event)"></app-upload-file>
						}
					
					</div>
				
				</div>
				
			}
		
		</form>
		
	}

</div>
